import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=1472cce4&scoped=true&"
import script from "./SocialMedia.vue?vue&type=script&lang=js&"
export * from "./SocialMedia.vue?vue&type=script&lang=js&"
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=1472cce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472cce4",
  null
  
)

export default component.exports